// InventoryListPopup.js
import React, { useEffect, useState } from 'react';
import api from '../utils/api'; 
import './styles/Kidola.css';

const InventoryListPopup = ({ onSelectItems, onClose }) => {
    const [inventories, setInventories] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const itemsPerPage = 50;

    useEffect(() => {
        handleSearch();
    }, [currentPage]);

    const handleSearch = async () => {
        try {
        const response = await api.post('/inventory/getInventoryList', {
            data: [{
            item_name: searchName,
            item_type: selectedType,
            }],
            limit: itemsPerPage,
            page: currentPage,
        });
        setInventories(response.data.data.inventoryList);
        setTotalData(response.data.data.totalCount);
        setTotalPages(Math.ceil(response.data.data.totalCount / itemsPerPage));
        } catch (error) {
        console.error("Failed to fetch inventories", error);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
        setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
        setCurrentPage(prevPage => prevPage - 1);
        }
    };
    
    const handleCheckboxChange = (inventoryId) => {
        setSelectedItems((prevSelected) => {
            if (prevSelected.includes(inventoryId)) {
                return prevSelected.filter((id) => id !== inventoryId); // Hapus item jika sudah dipilih
            } else {
                return [...prevSelected, inventoryId]; // Tambah item jika belum dipilih
            }
        });
    };

    const handleAddItems = () => {
        const selectedInventoryItems = inventories.filter(inventory => selectedItems.includes(inventory.inventory_id));
        onSelectItems(selectedInventoryItems); // Kirim item yang dipilih ke halaman utama
        onClose(); // Tutup popup setelah menambahkan item
    };
    

    return (
        <div className="popup">
            <h2>Inventory List</h2>
            <div className="search-container">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <label>Item Name</label>
                            </td>
                            <td>
                                <input
                                type="text"
                                placeholder="Enter item name"
                                value={searchName}
                                onChange={(e) => setSearchName(e.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label>Item Type</label>
                            </td>
                            <td>
                                <select
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                                >
                                <option value="">Select Type</option>
                                <option value="BOOK">BOOK</option>
                                <option value="OTHERS">OTHERS</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <button type="button" onClick={handleSearch}>Search</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="inventory-list">
                <table>
                    <thead>
                        <tr>
                            <th>Select</th>
                            <th className="no-column">No</th>
                            <th>Item Name</th>
                            <th>Item Type</th>
                            <th>Program</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inventories.map((inventory, index) => (
                        <tr key={inventory.inventory_id}>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={selectedItems.includes(inventory.inventory_id)}
                                    onChange={() => handleCheckboxChange(inventory.inventory_id)}
                                />
                            </td>
                            <td className="no-column">{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                            <td>{inventory.item_name}</td>
                            <td>{inventory.item_type}</td>
                            <td>{inventory.Program ? inventory.Program.program_name : ""}</td>
                            <td>{inventory.price}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="total-data">
                <span>Total Data: {totalData}</span>
            </div>
            <div className="pagination">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                    Prev
                                </button>
                            </td>
                            <td>
                                <span>Page {currentPage} of {totalPages}</span>
                            </td>
                            <td>
                                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="search-container">
                <button onClick={handleAddItems}>Add Selected Items</button>
                <button className="close-button" onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default InventoryListPopup;
